import { REDIRECT_PARAM } from './const';

export const getRedirectParam = (): string | null =>
  new URL(document.location.toString()).searchParams.get(REDIRECT_PARAM);
